/*eslint-disable */
const xmlog = {
  log(eventName, cb) {
    this._fbLog('track', 'Lead')
    this._googleAdLog(eventName, null , cb)
    
  },
  register(cb, mobile) {//预约
    this._fbLog('track', 'CompleteRegistration')
    this._tiktokLogRegister(mobile)
    this._lineLog()
    this._googleAdLog('conversion', 'AW-11114258999/QgcOCOzvhZEYELfE2LMp',() => {
      this._googleAdLog('add_phone', null, cb)  
    })
  },
  clickStore(cb) {
    this._fbLog('track', 'Lead')
    if (this._isIos()) {
      this._tiktokLogIOS()
    }else{
      this._tiktokLogAndroid()
    }
    this._googleAdLog('conversion', 'AW-11114258999/Ot-zCK7bjJEYELfE2LMp', () => {
      this._googleAdLog(this._isIos() ? 'iOS_Pre':'GP_Pre', null, cb)  
    })
  },
  fbLike(cb) {
    this._googleAdLog('FB_like', null, cb)  
  },
  gameStart(cb) {
    this._googleAdLog('Sword_test', null, cb)  
  },
  inviteFriend(cb) {
    this._googleAdLog('invite_friend', null, cb)  
  },
  joinFbGroup(cb) {
    this._googleAdLog('join_fbgroup', null, cb)  
  },
  _isIos() {
    let ua = navigator.userAgent;
    return /iphone|ipad|ipod/ig.test(ua);
  },
  _fbLog(a, b) {
    if (typeof fbq != 'undefined') {
      fbq(a, b)
    }
  },
  _tiktokLogRegister(mobile) {
    const PIXEL_CODE = 'CG5H1U3C77UFNRPAI6M0';
    const EVENT_NAME = 'SubmitForm'

    // Phone样例 正确格式：+886996123456  
    // 错误格式：+8860996123456 +886-996123456
    ttq.instance(PIXEL_CODE).identify({phone_number:mobile})
    ttq.instance(PIXEL_CODE).track(EVENT_NAME)
  },
  _tiktokLogFbShare() {
    const PIXEL_CODE = 'CG5H1U3C77UFNRPAI6M0';
    const EVENT_NAME = 'Subscribe'
    const DEDUP_KEY = 'fb_share' // You can define your de-dup key, e.g. session-id
    const DEDUP_VALUE_TIME = sessionStorage.getItem(DEDUP_KEY);
    const DEDUP_TIME_WINDOW = 1000 * 60 * 10; // 10 minutes, long enough
    
    if(DEDUP_VALUE_TIME === null) {
        /** Track for the first time */
        ttq.instance(PIXEL_CODE).track(EVENT_NAME);
        sessionStorage.setItem(DEDUP_KEY, Date.now());
    } else {
        try {
            if(Date.now() - DEDUP_VALUE_TIME > DEDUP_TIME_WINDOW) {
                /** Track for the second after tracking time window */
                ttq.instance(PIXEL_CODE).track(EVENT_NAME);
                sessionStorage.setItem(DEDUP_KEY, Date.now());
                console.log('longer than 10 min, send again')
            } else {
                /** Skip Tracking in short time window */
                console.log('Less than 10 min, skip sending')
            }
        } catch(err) {
            /** Unknown error, reset tracking and timing flag */
            ttq.instance(PIXEL_CODE).track(EVENT_NAME);
            sessionStorage.setItem(DEDUP_KEY, Date.now());
        }
    }
  },
  _tiktokLogIOS() {
    const PIXEL_CODE = 'CG5H1U3C77UFNRPAI6M0';
    const EVENT_NAME = 'Download'
    const DEDUP_KEY = 'ios_btn_time' // You can define your de-dup key, e.g. session-id
    const DEDUP_VALUE_TIME = sessionStorage.getItem(DEDUP_KEY);
    const DEDUP_TIME_WINDOW = 1000 * 60 * 10; // 10 minutes, long enough
    
    if(DEDUP_VALUE_TIME === null) {
        /** Track for the first time */
        ttq.instance(PIXEL_CODE).track(EVENT_NAME);
        sessionStorage.setItem(DEDUP_KEY, Date.now());
    } else {
        try {
            if(Date.now() - DEDUP_VALUE_TIME > DEDUP_TIME_WINDOW) {
                /** Track for the second after tracking time window */
                ttq.instance(PIXEL_CODE).track(EVENT_NAME);
                sessionStorage.setItem(DEDUP_KEY, Date.now());
                console.log('longer than 10 min, send again')
            } else {
                /** Skip Tracking in short time window */
                console.log('Less than 10 min, skip sending')
            }
        } catch(err) {
            /** Unknown error, reset tracking and timing flag */
            ttq.instance(PIXEL_CODE).track(EVENT_NAME);
            sessionStorage.setItem(DEDUP_KEY, Date.now());
        }
    }
  },
  _tiktokLogAndroid() {
    const PIXEL_CODE = 'CG5H1U3C77UFNRPAI6M0';
    const EVENT_NAME = 'Download'
    const DEDUP_KEY = 'and_btn_time' // You can define your de-dup key, e.g. session-id
    const DEDUP_VALUE_TIME = sessionStorage.getItem(DEDUP_KEY);
    const DEDUP_TIME_WINDOW = 1000 * 60 * 10; // 10 minutes, long enough

    if(DEDUP_VALUE_TIME === null) {
        /** Track for the first time */
        ttq.instance(PIXEL_CODE).track(EVENT_NAME);
        sessionStorage.setItem(DEDUP_KEY, Date.now());
    } else {
        try {
            if(Date.now() - DEDUP_VALUE_TIME > DEDUP_TIME_WINDOW) {
                /** Track for the second after tracking time window */
                ttq.instance(PIXEL_CODE).track(EVENT_NAME);
                sessionStorage.setItem(DEDUP_KEY, Date.now());
                console.log('longer than 10 min, send again')
            } else {
                /** Skip Tracking in short time window */
                console.log('Less than 10 min, skip sending')
            }
        } catch(err) {
            /** Unknown error, reset tracking and timing flag */
            ttq.instance(PIXEL_CODE).track(EVENT_NAME);
            sessionStorage.setItem(DEDUP_KEY, Date.now());
        }
    }
  },
  _lineLog() {
    if (typeof _lt != 'undefined') {
      _lt('send', 'cv', {  type: 'Conversion'},['e03b8e96-4bef-48b6-9ffd-d5fd4f057861'])
      _lt('send', 'cv', {  type: 'Conversion'},['2c1f9070-6609-46fc-b7e9-738a8d22b081'])
    }
  },
  _googleAdLog(eventName, sendTo, cb) {
    if (typeof gtag != 'undefined') {
      var p = {
        event_callback: (event) => {
          cb && cb()
        }
      }
      if (sendTo && sendTo.length > 0) {
        p.send_to = sendTo
      }
      gtag('event', eventName, p)
    }
  }
}

export default xmlog